import { TThemeColors } from './TThemeColors';
import { colors, primitives } from './ebds-colors.json';

export const lightThemeColors: TThemeColors = colors.light;

export const darkThemeColors: TThemeColors = colors.dark;

export const mode1ThemePrimatives = primitives.mode1;
